import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import { FleetActions } from '../../../actions';
import Loader from '../../../components/Loader';
import SubnavBar from '../../../components/SubnavBar';
import TitleBar from '../../../components/TitleBar';
import List from '../../../components/Fleet/Trackers/List';

class Trackers extends Component {
  constructor(props) {
    super(props);

    this.onSelect = this.onSelect.bind(this);
  }
  componentWillMount() {
    this.props.dispatch(FleetActions.getTrackers());
  }
  onSelect(values) {
    if (values.length > 0) {
      browserHistory.push(`/fleet/tracker/${values[0]}`);
    }
  }
  render() {
    const { auth, fleet } = this.props;
    const profile = auth.getProfile();
    const isAdmin = _.includes(profile.roles, 'admin');
    let content;
  
    if (!fleet || !fleet.trackers || fleet.trackers.fetching) {
      content = <Loader />;
    } else {
      if (fleet.trackers.list.length === 0) {
        content = <h2>No Tracker Devices</h2>;
      } else {
        content = <List dataProvider={fleet.trackers.list} isAdmin={isAdmin} multiSelectable={false} onRowSelection={this.onSelect} />;
      }
    }

    const subnavItems = []
    return (
      <div className="row">
        <div className="col s12">
          <SubnavBar items={subnavItems} />
          <TitleBar title="Trackers" />
          <div className="row">
            <div className="col s12">
              {content}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { auth, fleet } = state;
  return {
    auth: auth.auth,
    fleet,
  }
}

export default connect(mapStateToProps)(Trackers);



// WEBPACK FOOTER //
// ./src/containers/Fleet/Trackers/index.js